import {createReducer} from '@reduxjs/toolkit';

import {closeSnackbar} from 'notistack';
import {dismissNotification, notify} from '../actions/notifications.js';

const initialState = {
  notification: null,
};

const notifications = createReducer(initialState, builder => {
  builder.addCase(notify, (state, {payload}) => {
    state.notification = payload;
  });

  builder.addCase(dismissNotification, (state, {payload: key}) => {
    closeSnackbar(key);
    state.notification = null;
  });
});

export default notifications;
